import { PATIENT_AUTH_STORAGE_KEY } from "../../../constants/patientAuthStorage";
import { accessTokenExpiresAtMs } from "./patientAccessRefresh";

const parseJson = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch (_error) {
    return null;
  }
};

export const clearProgramAuthentication = () => {
  [
    PATIENT_AUTH_STORAGE_KEY.runtimeAccessToken,
    PATIENT_AUTH_STORAGE_KEY.runtimeAccessExpiresAt,
    PATIENT_AUTH_STORAGE_KEY.patientInfo,
    PATIENT_AUTH_STORAGE_KEY.prefillData,
  ].forEach((key) => sessionStorage.removeItem(key));
};

export const storeProgramAuthentication = ({
  accessToken,
  accessTokenExpiresIn,
  patient,
  profile,
}) => {
  clearProgramAuthentication();
  if (!accessToken || !patient) return;

  sessionStorage.setItem(
    PATIENT_AUTH_STORAGE_KEY.runtimeAccessToken,
    accessToken,
  );
  const serverExpiresAt = Date.now() + (Number(accessTokenExpiresIn || 3600) * 1000);
  sessionStorage.setItem(
    PATIENT_AUTH_STORAGE_KEY.runtimeAccessExpiresAt,
    String(Math.min(serverExpiresAt, accessTokenExpiresAtMs(accessToken))),
  );
  sessionStorage.setItem(
    PATIENT_AUTH_STORAGE_KEY.patientInfo,
    JSON.stringify(patient),
  );
  sessionStorage.setItem(
    PATIENT_AUTH_STORAGE_KEY.prefillData,
    JSON.stringify({ patient, profile }),
  );
};

export const loadProgramAuthentication = () => {
  const accessToken = sessionStorage.getItem(
    PATIENT_AUTH_STORAGE_KEY.runtimeAccessToken,
  );
  const expiresAt = Number(
    sessionStorage.getItem(PATIENT_AUTH_STORAGE_KEY.runtimeAccessExpiresAt),
  );
  const patient = parseJson(
    sessionStorage.getItem(PATIENT_AUTH_STORAGE_KEY.patientInfo),
  );
  const prefillData = parseJson(
    sessionStorage.getItem(PATIENT_AUTH_STORAGE_KEY.prefillData),
  );

  if (!accessToken || !patient || !expiresAt || Date.now() >= expiresAt) {
    clearProgramAuthentication();
    return null;
  }
  return {
    authenticated: true,
    accessToken,
    accessTokenExpiresIn: Math.max(
      1,
      Math.floor((expiresAt - Date.now()) / 1000),
    ),
    patient,
    prefillData,
  };
};

export const updateProgramAuthenticationProfile = ({ patient, profile }) => {
  const current = loadProgramAuthentication();
  if (!current) return null;
  const nextPatient = patient || current.patient;
  sessionStorage.setItem(
    PATIENT_AUTH_STORAGE_KEY.patientInfo,
    JSON.stringify(nextPatient),
  );
  sessionStorage.setItem(
    PATIENT_AUTH_STORAGE_KEY.prefillData,
    JSON.stringify({ patient: nextPatient, profile }),
  );
  return loadProgramAuthentication();
};
